var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFullscreenExit24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 13.9a.9.9 0 0 1 .9-.9h4.2a.9.9 0 0 1 .9.9v4.2a.9.9 0 1 1-1.8 0v-2.027l-3.664 3.663a.9.9 0 1 1-1.272-1.272L7.927 14.8H5.9a.9.9 0 0 1-.9-.9zm14.736-9.636a.9.9 0 0 1 0 1.272L16.073 9.2h2.025a.9.9 0 0 1 0 1.8H13.9a.9.9 0 0 1-.9-.9V5.9a.9.9 0 1 1 1.8 0v2.027l3.664-3.663a.9.9 0 0 1 1.272 0z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreenExit24);
export default __webpack_public_path__ + "static/media/fullscreen_exit_24.de9290e2.svg";
export { ForwardRef as ReactComponent };